import { createRouter, createWebHistory } from 'vue-router'
import { useWebSiteStore } from '@/stores/web-site.store'
import { permissionFlagEnum } from '@/stores/portal.store'
import { refreshAllStoresAsync } from '@/composables/store'
import { menuRouteEnum, menuRoutes } from '@/lib/menu-routes'

import DefaultLayout from './views/layouts/DefaultLayout.vue'
import DashboardPage from './views/protected/DashboardPage.vue'
import AboutPage from './views/protected/AboutPage.vue'
import CompanyPage from './views/protected/accounting/CompanyPage.vue'
import ActivationPage from './views/public/ActivationPage.vue'
import ProjectsPage from './views/protected/planner/ProjectsPage.vue'
import EquipmentsPage from './views/protected/planner/EquipmentsPage.vue'
import TimelinePage from './views/protected/planner/TimelinePage.vue'
import StaffsPage from './views/protected/planner/StaffsPage.vue'
import StaffMovementsPage from './views/protected/planner/StaffMovementsPage.vue'
import ListingsPage from './views/protected/planner/ListingsPage.vue'
import CompaniesPage from './views/protected/planner/CompaniesPage.vue'
import RoiComparisonPage from './views/protected/planner/RoiComparisonPage.vue'
import GroupsPage from './views/protected/planner/GroupsPage.vue'
import WarehousePage from './views/protected/planner/WarehousePage.vue'
import WarehouseStockPage from './views/protected/planner/WarehouseStockPage.vue'
import WarehousePivotPage from './views/protected/planner/WarehousePivotPage.vue'
import ProjectDetailsPage from './views/protected/planner/ProjectDetailsPage.vue'
import LoginPage from './views/public/LoginPage.vue'
import EventSchedulerPage from './views/protected/event/EventSchedulerPage.vue'
import NotificationsPage from './views/protected/NotificationsPage.vue'
import BudgetDocumentsPage from './views/protected/accounting/BudgetDocumentsPage.vue'
import CostReportsPage from './views/protected/accounting/CostReportsPage.vue'
import InvoicesPage from './views/protected/accounting/InvoicesPage.vue'
import ReportsPage from './views/protected/accounting/ReportsPage.vue'
import ExpenseClaimsPage from './views/protected/accounting/ExpenseClaimsPage.vue'

export { menuRouteEnum, menuRoutes }

const routes = [
  {
    path: '/activation', component: ActivationPage, meta: { allowAny: true, clearAuth: true }
  },
  {
    path: menuRoutes[menuRouteEnum.LOGIN], component: LoginPage, meta: { allowAny: true }
  },
  {
    path: menuRoutes['menu.home'],
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'home',
        meta: { reference: menuRouteEnum.HOME },
        component: DashboardPage,
      },
      {
        name: 'company',
        meta: { reference: menuRouteEnum.COMPANY },
        path: menuRoutes[menuRouteEnum.COMPANY],
        component: CompanyPage,
      },
      {
        name: 'accounting-budget-documents',
        meta: {
          reference: menuRouteEnum.ACCOUNTING_BUDGET_DOCUMENTS,
          permission: permissionFlagEnum.QUOTES_VIEW,
          signalBar: 'quotes',
        },
        path: menuRoutes[menuRouteEnum.ACCOUNTING_BUDGET_DOCUMENTS],
        component: BudgetDocumentsPage,
      },
      {
        name: 'accounting-cost-reports',
        meta: { reference: menuRouteEnum.ACCOUNTING_COST_REPORTS },
        path: menuRoutes[menuRouteEnum.ACCOUNTING_COST_REPORTS],
        component: CostReportsPage,
      },
      {
        name: 'accounting-invoices',
        meta: {
          reference: menuRouteEnum.ACCOUNTING_INVOICES,
          permission: permissionFlagEnum.INVOICING_VIEW,
          bottomTabs: true,
        },
        path: menuRoutes[menuRouteEnum.ACCOUNTING_INVOICES],
        component: InvoicesPage,
      },
      {
        name: 'accounting-reports',
        meta: {
          reference: menuRouteEnum.ACCOUNTING_REPORTS,
          bottomTabs: true,
        },
        path: menuRoutes[menuRouteEnum.ACCOUNTING_REPORTS],
        component: ReportsPage,
      },
      {
        name: 'accounting-expense-claims',
        meta: {
          reference: menuRouteEnum.ACCOUNTING_EXPENSE_CLAIMS,
        },
        path: menuRoutes[menuRouteEnum.ACCOUNTING_EXPENSE_CLAIMS],
        component: ExpenseClaimsPage,
      },
      {
        name: 'projects',
        meta: { reference: menuRouteEnum.PROJECTS, signalBar: 'projects' },
        path: menuRoutes[menuRouteEnum.PROJECTS],
        component: ProjectsPage,
      },
      {
        name: 'project-detail',
        meta: { reference: menuRouteEnum.PROJECTS },
        path: menuRoutes[menuRouteEnum.PROJECTS] + '/?:id',
        component: ProjectDetailsPage,
      },
      {
        name: 'equipments',
        meta: { reference: menuRouteEnum.EQUIPMENTS, signalBar: 'equipments' },
        path: menuRoutes[menuRouteEnum.EQUIPMENTS],
        component: EquipmentsPage,
      },
      {
        name: 'timeline',
        meta: { reference: menuRouteEnum.TIMELINE },
        path: menuRoutes[menuRouteEnum.TIMELINE],
        component: TimelinePage,
      },
      {
        name: 'staffs',
        meta: { reference: menuRouteEnum.STAFFS, signalBar: 'staffs' },
        path: menuRoutes[menuRouteEnum.STAFFS],
        component: StaffsPage,
      },
      {
        name: 'staff-movements',
        meta: {
          reference: menuRouteEnum.STAFF_MOVEMENTS,
          bottomTabs: true,
          permission: permissionFlagEnum.APPROVALS,
        },
        path: menuRoutes[menuRouteEnum.STAFF_MOVEMENTS],
        component: StaffMovementsPage,
      },
      {
        name: 'companies',
        meta: { reference: menuRouteEnum.COMPANIES, signalBar: 'companies' },
        path: menuRoutes[menuRouteEnum.COMPANIES],
        component: CompaniesPage,
      },
      {
        name: 'roi-comparison',
        meta: {
          reference: menuRouteEnum.ROI_COMPARISON,
          permission: permissionFlagEnum.FINANCIALS,
        },
        path: menuRoutes[menuRouteEnum.ROI_COMPARISON],
        component: RoiComparisonPage,
      },
      {
        name: 'groups',
        meta: { reference: menuRouteEnum.GROUPS },
        path: menuRoutes[menuRouteEnum.GROUPS],
        component: GroupsPage,
      },
      {
        name: 'listings',
        meta: {
          reference: menuRouteEnum.LISTINGS,
          permission: permissionFlagEnum.RATE_CARDS_VIEW,
        },
        path: menuRoutes[menuRouteEnum.LISTINGS],
        component: ListingsPage,
      },
      {
        name: 'warehouse-list',
        meta: { reference: menuRouteEnum.WAREHOUSE_LIST, bottomTabs: true },
        path: menuRoutes[menuRouteEnum.WAREHOUSE_LIST],
        component: WarehousePage,
      },
      {
        name: 'warehouse-stock',
        meta: { reference: menuRouteEnum.WAREHOUSE_STOCK },
        path: menuRoutes[menuRouteEnum.WAREHOUSE_STOCK],
        component: WarehouseStockPage,
      },
      {
        name: 'warehouse-pivot',
        meta: { reference: menuRouteEnum.WAREHOUSE_PIVOT },
        path: menuRoutes[menuRouteEnum.WAREHOUSE_PIVOT],
        component: WarehousePivotPage,
      },
      {
        name: 'notifications',
        meta: { reference: menuRouteEnum.NOTIFICATIONS, bottomTabs: true },
        path: menuRoutes[menuRouteEnum.NOTIFICATIONS],
        component: NotificationsPage,
      },
      {
        name: 'events-scheduler',
        meta: { reference: menuRouteEnum.EVENT_SCHEDULER },
        path: menuRoutes[menuRouteEnum.EVENT_SCHEDULER],
        component: EventSchedulerPage,
      },
      { path: menuRoutes[menuRouteEnum.ABOUT], component: AboutPage },
    ]
  }
]

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

let firstTimeCheck = true

router.beforeEach(async(to, from, next) => {
  const webSiteStore = useWebSiteStore()
  if (firstTimeCheck && !to.meta.allowAny) {
    firstTimeCheck = false
    try {
      await webSiteStore.autoLoginAsync()
    } catch {
      next(menuRoutes[menuRouteEnum.LOGIN])
    }
  }

  if (to.meta.clearAuth) {
    webSiteStore.$reset()
  }

  if (!to.meta.allowAny) {
    const isAuthenticated = webSiteStore.isAuthenticated()
    if (isAuthenticated) {
      await refreshAllStoresAsync()
    }
  }

  if (to.meta.permission !== undefined && (!webSiteStore.isAuthenticated() || !webSiteStore.can(to.meta.permission))) {
    return next(menuRoutes[menuRouteEnum.HOME])
  }

  to.meta.allowAny || webSiteStore.isAuthenticated() ? next() : next(menuRoutes[menuRouteEnum.LOGIN])
})

export default router
